'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dec, _class, _desc, _value, _class2;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ContentElement2 = require('../layouts/ContentElement');

var _ContentElement3 = _interopRequireDefault(_ContentElement2);

var _magicTransport = require('magic-transport');

var _DOM = require('../utils/DOM');

var _decorators = require('../utils/decorators');

var _viewport = require('../utils/DOM/viewport');

var _EventEmitter = require('../utils/EventEmitter');

var _EventEmitter2 = _interopRequireDefault(_EventEmitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Resizer = function () {
  function Resizer(container, transport) {
    _classCallCheck(this, Resizer);

    this.container = container;
    this.transport = transport;
  }

  _createClass(Resizer, [{
    key: 'resize',
    value: function resize() {
      var _this = this;

      return this.transport.consumer.getSize().then(function (size) {
        _this.setSize(size);
      });
    }
  }, {
    key: 'setSize',
    value: function setSize(_ref) {
      var height = _ref.height;

      this.container.style.height = height + 'px';
    }
  }]);

  return Resizer;
}();

var IFrameProvider = (_dec = (0, _decorators.mixin)(_EventEmitter2.default.prototype), _dec(_class = (_class2 = function (_ContentElement) {
  _inherits(IFrameProvider, _ContentElement);

  /**
   * Обертка над iframe
   * @param {String} options.url - URL по которому нужно загрузить iframe
   * @param {Widget} options.widget - Объект виджета
   * @param {String} options.id - Уникальный идентификатор виджета
   * @param {Function} options.reduceViewportChange - Метод создания замедления
   *
   * @events
   * viewportChange - событие которое вызывается, когда вьюпорт элемента изменени
   */
  function IFrameProvider(url, widget, id, reduceViewportChange) {
    _classCallCheck(this, IFrameProvider);

    var _this2 = _possibleConstructorReturn(this, (IFrameProvider.__proto__ || Object.getPrototypeOf(IFrameProvider)).call(this));

    _EventEmitter2.default.call(_this2);
    // Создаем элемент iframe
    _this2.id = id;
    _this2.url = url + (url.indexOf('#') === -1 ? '#' : '&') + 'widgetId=' + _this2.id;
    _this2.widget = widget;
    _this2.reduceViewportChange = reduceViewportChange;

    _this2._destroyed = false;

    var _ref2 = new URL(url),
        protocol = _ref2.protocol,
        host = _ref2.host;

    if (host) _this2.consumerOrigin = protocol + '//' + host;else _this2.consumerOrigin = location.origin;
    _this2.createElement();
    return _this2;
  }

  _createClass(IFrameProvider, [{
    key: 'createElement',
    value: function createElement() {
      this.element = document.createElement('iframe');
      this.element.style.display = 'block !important';
      this.element.setAttribute('frameborder', 'no');
      this.element.setAttribute('width', '100%');
      this.element.setAttribute('scrolling', 'no');
      this.element.name = this.id;
      this.element.id = this.id;
      this.element.src = this.url;
      (0, _DOM.onRemoveFromDOM)(this.element, this.destroy);
    }
  }, {
    key: 'initialize',
    value: function initialize() {
      var _this3 = this;

      this.transport = new _magicTransport.Provider(this.id, this.consumerOrigin, _extends({}, this.widget.externalizeAsProvider(), {
        resize: function resize() {
          return _this3.resizer.resize();
        },
        setSize: function setSize(size) {
          return _this3.resizer.setSize(size);
        }
      }));
      this.resizer = new Resizer(this.element, this.transport);
      this.provider = this.transport.provider;
      return new Promise(function (resolve) {
        return _this3.transport.once('ready', resolve);
      }).then(function (consumer) {
        _this3.consumer = consumer;
      }).then(function () {
        return _this3.consumer.initialize();
      }).then(function () {
        return _this3.resizer.resize();
      }).then(function () {
        _this3.consumer.watchSize();
        return _this3.consumer;
      });
    }

    /**
     * Подписка на изменение видимой области iframe
     * @param {Function}  callback
     * @return {Function} Функция отписки от события
     */

  }, {
    key: 'subscribeVisibleAreaChange',
    value: function subscribeVisibleAreaChange(callback) {
      var _this4 = this;

      this._subscribeViewportChange();
      var withCallback = function withCallback() {
        callback(_this4.getVisibleArea());
      };
      this.on('viewportChange', withCallback);
      var unsubscribeVisibleAreaChange = function unsubscribeVisibleAreaChange() {
        _this4.removeListener('viewportChange', withCallback);
      };
      return unsubscribeVisibleAreaChange;
    }
  }, {
    key: 'getVisibleArea',
    value: function getVisibleArea() {
      return (0, _viewport.getVisibleArea)(this.element);
    }
  }, {
    key: '_subscribeViewportChange',
    value: function _subscribeViewportChange() {
      if (!this.viewportManager) this.viewportManager = (0, _DOM.createViewportManager)(this.element, this.updateViewport, this.reduceViewportChange);
    }

    /**
     * Обработчик скролла
     */

  }, {
    key: 'updateViewport',
    value: function updateViewport() {
      this.emit('viewportChange');
    }

    /**
     * Пересчитать размеры айфрейма
     */

  }, {
    key: 'resize',
    value: function resize() {
      this.resizer.resize();
    }

    /**
     * Метод вызывается при удалении айфрейма
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      (0, _DOM.removeFromDOM)(this.element);
      this.emit('destroy');
      this.transport.destroy();
      this.removeAllListeners();
      if (this.viewportManager) this.viewportManager.destroy();
    }
  }]);

  return IFrameProvider;
}(_ContentElement3.default), (_applyDecoratedDescriptor(_class2.prototype, '_subscribeViewportChange', [_decorators.once], Object.getOwnPropertyDescriptor(_class2.prototype, '_subscribeViewportChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateViewport', [_decorators.autobind], Object.getOwnPropertyDescriptor(_class2.prototype, 'updateViewport'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'destroy', [_decorators.autobind, _decorators.once], Object.getOwnPropertyDescriptor(_class2.prototype, 'destroy'), _class2.prototype)), _class2)) || _class);
exports.default = IFrameProvider;